@if (open) {
  <div class="modal__backdrop" (click)="onBackdropClick()">
    <!--
      cdkTrapFocus + cdkTrapFocusAutoCapture: captures focus into the dialog on
      open and returns it to the previously-focused element on close (the whole
      subtree is created/destroyed by the @if above, which is what drives the
      capture/restore lifecycle). Clicks inside the dialog are stopped so they
      don't reach the backdrop's close handler.
    -->
    <div
      class="modal__dialog"
      [ngClass]="'modal__dialog--' + size"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-labelledby]="ariaLabel ? null : headerId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (click)="$event.stopPropagation()"
      (keydown.escape)="onEscape($event)"
    >
      <header class="modal__header" [id]="headerId">
        <div class="modal__header-content">
          <ng-content select="[modal-header]"></ng-content>
        </div>
        @if (showCloseButton) {
          <button
            type="button"
            class="modal__close"
            aria-label="Close"
            [attr.data-testid]="closeTestId"
            (click)="requestClose()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        }
      </header>

      <div class="modal__body">
        <ng-content select="[modal-body]"></ng-content>
        <ng-content></ng-content>
      </div>

      <footer class="modal__footer">
        <ng-content select="[modal-footer]"></ng-content>
      </footer>
    </div>
  </div>
}
